const table202 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "payable_interest_liabilities_current_period",
        name: "当期に支払う利子等の額",
        editable: true
    },
    {
        key: "non_deductible_amount",
        name: "国外支配株主等に係る負債の利子等の損金不算入額、対象純支払利子等の損金不算入額又は恒久的施設に帰せられるべき資本に対応する負債の利子の損金不算入額",
        editable: true
    },
    {
        key: "payable_interest_liabilities_consolidated_corp",
        name: "超過利子額の損金算入額",
        editable: true
    },
    {
        key: "payable_interest_liabilities_other_corp",
        name: "他の通算法人に対する支払利子等の額",
        editable: true
    }
];

export { table202 };
